import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-list.tsx
var LazyCourseList = lazy(() => import("./course-list-CQwW6dva.js").then((n) => n.n).then((module) => ({ default: module.CourseList })));
function CourseList({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-list" }),
		children: /* @__PURE__ */ jsx(LazyCourseList, { ...props })
	});
}
function CourseListContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-list" }),
		children: /* @__PURE__ */ jsx(LazyCourseList, { ...props })
	});
}
var useCourseListContent = () => {
	return useMemo(() => ({ coursesList: { component: CourseListContent } }), []);
};
//#endregion
export { CourseList, useCourseListContent };
